/* unplugin-vue-components disabled */import script from "./info.vue?vue&type=script&setup=true&lang=js"
export * from "./info.vue?vue&type=script&setup=true&lang=js"

import "./info.vue?vue&type=style&index=0&id=2e962a57&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e962a57"]])

export default __exports__